import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ButtonService, ComboService, EngDynamicFormsComponent, FormContainerConfig, IForm, MrfFormComponent, ConditionalService, UtilityService, IFormElement } from '@eng/morfeo';
import { ActivatedRoute, ChildActivationStart, Router } from '@angular/router';
import { TemplateService } from 'src/app/services/template.service';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AbstractControl, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { SegnalazioniService } from 'src/app/services/segnalazioni.service';
import { DialogService } from 'src/app/services/dialog.service';
import { DatePipe } from '@angular/common';
import { MapComponent } from '../map/map.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from "../../../environments/environment";
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { EventiService } from 'src/app/services/eventi.service';
import { SegnalazioneEditabileService } from 'src/app/services/segnalazione-editabile.service';
import { Subscription, timer } from 'rxjs';
import { EntiService } from 'src/app/services/enti.service';
import { debug } from 'console';

@Component({
  selector: 'app-compilazione-segnalazione',
  templateUrl: './compilazione-segnalazione.component.html',
  styleUrls: ['./compilazione-segnalazione.component.css']
})
export class CompilazioneSegnalazioneComponent implements OnInit, OnDestroy, AfterViewChecked {
  private NOMI_FUNZIONI_CONSENTITE: string[] = ['funzioneProvaInizializzazione', 'funzioneProvaVariazione'];
  isLoading: boolean = false;
  public formJson: IForm = { "components": [] }
  public form: FormGroup;
  public templateList: ModelEventiCalamitosi.TemplateDto[] = [];
  isDettaglio: boolean;
  isModifica: boolean;
  isDettaglioStoricoSegnalazione: boolean;
  acl: string = '';
  showBtnAnomalie: boolean = false;
  abilitazioniPerSegnalazione: { canDgpeUpdate: boolean, canDpcplUpdate: boolean, canUpdate: boolean } = { canDgpeUpdate: false, canDpcplUpdate: false, canUpdate: false };
  abilitazioniSegnalazioneEELL: ModelEventiCalamitosi.AbilitazioniEnteSuSegnalazione = { abilitatoRaccolta: false, abilitatoCorrezione: false, statoInterventoAssociato: '' };

  public idTemplate: number;
  //@ViewChild(EngDynamicFormsComponent) formRef: EngDynamicFormsComponent;
  @ViewChild(MrfFormComponent) formRef: MrfFormComponent;
  segnalazioneData: ModelEventiCalamitosi.AnaDatiRaccoltiDTO;
  segnalazioneDTO: ModelEventiCalamitosi.SegnalazioneDto;
  isNewSegnalazione: boolean;
  statoSegnalazione: string;
  statoIntervento: string = '';
  dataStoricizzazione: any;
  components: any = [];
  canUpdate: boolean = false;
  statoEvento: string = '';
  isEditableForDPCPL: boolean = false;
  isRevisionata: boolean = false;
  sottoscrizione: Subscription;
  sottoscrizioneFLRettificata: Subscription;
  recuperatoFormMorfeo: boolean = false;
  public formSubmit: FormContainerConfig = {}

  constructor(
    private conditionalService: ConditionalService,
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private templateService: TemplateService,
    private entiService: EntiService,
    private alertsCenterService: AlertsCenterService,
    private segnalazioniService: SegnalazioniService,
    private segnalazioneEditabileService: SegnalazioneEditabileService,
    public dialog: MatDialog,
    private dialogSvc: DialogService,
    private buttonService: ButtonService,
    private eventoService: EventiService,
    private utils: UtilityService,
    private comboService: ComboService

  ) {

    this.modeSelector();
    if (this.router.url.includes('dettaglio-segnalazione-storico')) {
      this.isDettaglioStoricoSegnalazione = true;
      if (this.router.getCurrentNavigation().extras.state !== undefined) {
        this.dataStoricizzazione = this.router.getCurrentNavigation().extras.state.storicizzazione;
      } else {
        this.onNavigate();
      }
    }

    if (this.route.snapshot.params.idSegnalazione) {
      let idSegnalazione = this.route.snapshot.params.idSegnalazione

      this.segnalazioniService.checkIfEditabile(idSegnalazione).subscribe(
        res => {
          this.abilitazioniPerSegnalazione = res;
          this.canUpdate = res.canUpdate;
        },
        err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        }
      );

      this.segnalazioniService.segnalazioneHasErrors(idSegnalazione).subscribe(
        res => {
          if (res > 0) this.showBtnAnomalie = true;
        },
        err => {
          this.alertsCenterService.showAlert({
            message: 'Errore nel recupero deti dati relativi gli errori della segnalazione',
            type: 'danger',
            autoClosable: false,
          });
        })

      this.segnalazioniService.getSegnalazione(idSegnalazione).subscribe(
        segn => {
          this.entiService.checkPermessiEELLperSegnalazione(segn.idDatiRaccolti).subscribe(res => {
            this.abilitazioniSegnalazioneEELL = res;
          },
            err => {
              this.alertsCenterService.showAlert({
                message: `Errore in recupero informazioni abilitazione ente`,
                type: 'danger',
                autoClosable: false
              });
            });

          if (segn.flRettificata === 'S') this.isRevisionata = true;
          this.eventoService.getEvento(segn.idEvento).subscribe(res => {
            this.statoEvento = res.stato;
            this.statoSegnalazione = segn.stato;
            this.statoIntervento = segn.statoIntervento;


          });
        }
      )
    } else
      //nuova segnalazione
      this.canUpdate = true;
  }

  ngAfterViewChecked(): void {
    //if is only read disable checkbox
    if(!this.isModifica){
      //console.log(document.getElementsByClassName('mat-checkbox-input cdk-visually-hidden'));
      try {
        // Get elements by class name
        const checkboxes = document.getElementsByClassName('mat-checkbox-input cdk-visually-hidden');

        // Convert to array for consistent forEach behavior
        Array.from(checkboxes).forEach((element: Element) => {
          const checkbox = element as HTMLInputElement;
          if (checkbox) {
            const isInsideDialog = checkbox.closest('mat-dialog-container');
            if (isInsideDialog) {
                return;
            }
            checkbox.disabled = true;
            checkbox.setAttribute('aria-disabled', 'true');
          }
        });

        //console.log(`Disabled ${checkboxes.length} Angular Material checkboxes`);
      } catch (error) {
        //console.error('Failed to disable Angular Material checkboxes:', error);
      }
    }
  }

  ngOnInit(): void {

    //Aggiungo funzione varValute
    //prende la valuta e toglie la virgola
    var varValute = function (value: string) {
      if (value !== null) {
        return parseFloat(value.replace(",", "."));
      } else {
        return null;
      }
    };

    //Aggiungo funzione upper
    var upperC = function (value: string) {
      if (value !== null) {
        return value.toUpperCase();
      } else {
        return null;
      }
    };
    //Aggiungo somma valute
    var sommaValute = function (addendi: number[]) {
      let result: number = 0;
      addendi.forEach(addendo => {
        if (addendo === null || addendo === undefined || addendo.toString() === '' || !addendo.toString().includes(",")) addendo = 0;
        addendo = +(addendo.toString().replace(",", ""));
        result += addendo;
      });

      let stringResult = (result / 100).toString().replace(".", ",");

      if (!stringResult.includes(",")) stringResult += ",00"
      else {
        let cifre = stringResult.split(",");
        let nCifreDecimali = cifre[1];
        stringResult = nCifreDecimali.length === 1 ? stringResult += '0' : stringResult
      }

      return stringResult;
    };

    this.conditionalService.jsonLogic.add_operation("varValute", varValute);
    this.conditionalService.jsonLogic.add_operation("upperC", upperC);
    this.conditionalService.jsonLogic.add_operation("sommaValute", sommaValute);

    this.acl = sessionStorage.getItem("acl");

    this.sottoscrizione = this.segnalazioneEditabileService.modificatoStatoObservable.subscribe(nuovoStato => {
      this.statoSegnalazione = nuovoStato;
    });

    // Quando riapro una segnalazione questa sottoscrizione
    // permette di controllare il flag rettificata
    // Questo flag viene emesso SOLO QUANDO una segnalazione RIF viene riaperta
    this.sottoscrizioneFLRettificata = this.segnalazioneEditabileService.sendFlRettificataObservable.subscribe(flagRett => {
      this.isRevisionata = flagRett === 'S' ? true : this.isRevisionata;
    });

    //Riempio select con template associati all'evento
    //eliminato isModifica dal primo if poichè non appariva il template associato in mod modifica
    if ((this.isNewSegnalazione) && !(this.acl == AclTipo.DGPE)) {
      this.segnalazioniService.getTemplatePerCompilazione(this.route.snapshot.params.id).subscribe(res => {
        this.templateList = res;
      })
    } else {
      this.segnalazioniService.getTemplatePerCompilazione(this.route.snapshot.params.id, this.route.snapshot.params.idSegnalazione).subscribe(res => {
        this.templateList = res;
      })
    }

  }

  public ngAfterViewInit() {
    let idSegnalazione = this.route.snapshot.params.idSegnalazione;

    this.formRef.formReadyEvent.subscribe(f => {
      if (idSegnalazione != null) {
        if (!this.segnalazioneData) {
          return;
        }

        const subscription = timer(0, 100).subscribe(val => {
          let rend = this.isAlmenoUnElementoRenderizzato();
          if (rend || val > 10) { //in ogni caso dopo un secondo tenta di fare gli assign
            subscription.unsubscribe();
            f.form.setValue(
              this.segnalazioneData.jsonAttributiMap as string
            );
            this.morfeoValidation(f.form);
            this.eseguiFunzioniInizializzazioneJS(f.form);
            this.preparaFunzioniVariazione(f.form);
            if (!this.isModifica) {
              f.form.disable();
            }
          }
        });
      } else {
        const subscription = timer(0, 100).subscribe(val => {
          let rend = this.isAlmenoUnElementoRenderizzato();
          if (rend || val > 10) { //in ogni caso dopo un secondo tenta di fare gli assign
            subscription.unsubscribe();
            this.morfeoValidation(f.form);
            this.eseguiFunzioniInizializzazioneJS(f.form);
            this.preparaFunzioniVariazione(f.form);
          }
        });
      }
    });


    if (idSegnalazione != null) {
      if (this.isDettaglioStoricoSegnalazione) {
        this.segnalazioniService.getSegnalazioneStorica(idSegnalazione, this.dataStoricizzazione).subscribe(segnStorica => {
          this.segnalazioneData = segnStorica;
          this.form.controls.descrizione.setValue(segnStorica.descrizione);
          this.form.controls.idTemplateSelect.setValue(segnStorica.idTemplate);
          this.form.controls.idDatiRaccolti.setValue(segnStorica.idDatiRaccolti);
          this.caricaFormMorfeo(this.segnalazioneData.idTemplate, this.segnalazioneData.idDatiRaccolti, this.dataStoricizzazione);
        })
      } else {
        this.segnalazioniService.getSegnalazione(idSegnalazione).subscribe(ret => {
          this.segnalazioneData = ret;
          this.form.controls.descrizione.setValue(ret.descrizione);
          this.form.controls.idTemplateSelect.setValue(ret.idTemplate);
          // disabilito dopo valorizzazione
          this.form.controls.idTemplateSelect.disable();
          this.form.controls.idDatiRaccolti.setValue(ret.idDatiRaccolti);
          this.caricaFormMorfeo(this.segnalazioneData.idTemplate, this.segnalazioneData.idDatiRaccolti);
        }, err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        });
      }
    } else {
      //dobbiamo creare una nuova segnalazione
    }
  }

  private preparaFunzioniVariazione(form: FormGroup) {

    this.formJson.components
      // da BE viene mandato solo se effettivamente valorizzato, sennò abbiamo null
      .filter(comp => { return (comp.content !== null && comp.content['funzioneVariazione']) })
      .forEach(comp => {
        const nameFunctionVariazione = comp.content['funzioneVariazione'];

        if (this.checkIfFunctionIsLegal(nameFunctionVariazione)) {
          form.get(comp.key).valueChanges.subscribe(res => {
            if (res !== null && res !== undefined) {
              this[nameFunctionVariazione]();
            }
          });
        } else {
          console.log('La funzione con nome:' + nameFunctionVariazione + ' non è inclusa nella lista delle funzioni consentite')
        }
      })
  }

  // Funzione necessaria per inizializzazione tramite funzione js -> esempio caricamento opzioni generiche
  private eseguiFunzioniInizializzazioneJS(form: FormGroup) {

    this.formJson.components
      .filter(comp => { return (comp.content !== null && comp.content['funzioneInizializzazione']) })
      .forEach(comp => {
        const nameFunctionInizializzazione = comp.content['funzioneInizializzazione'];

        if (this.checkIfFunctionIsLegal(nameFunctionInizializzazione)) {
          this[nameFunctionInizializzazione](comp);
        } else {
          console.log('La funzione con nome:' + nameFunctionInizializzazione + ' non è inclusa nella lista delle funzioni consentite')
        }

      })
  }

  private checkIfFunctionIsLegal(nomeFunzione: string) {
    if (nomeFunzione !== null && nomeFunzione !== '' && this.NOMI_FUNZIONI_CONSENTITE.includes(nomeFunzione)) {
      return true;
    } else return false;
  }

  // Variazione campo con esecuzione di funzioni JS
  public funzioneProvaVariazione() {
    console.log('eseguo il codice alla variazione....');
    console.log('esempio di codice alla variazione')
    // Inserire nel form.get() il nome del campo che si intende cambiare, per adesso è cablato
    // this.formRef.f.form.get('campoconPrevalorizzazione').setValue('Il campo ora è cambiato grazie alla select')
  }

  // Inizializzazione campo con funzione JS
  public funzioneProvaInizializzazione(comp: IFormElement) {
    console.log("eseguo il codice all'inizializzazione....");
    const op = [];
    for (let index = 0; index < 10; index++) {
      op.push({ label: 'Opzione num ' + index, value: index });
    }
    this.comboService.setList(comp.key, op);
  }

  private buildForm() {
    this.form = new FormGroup({
      idDatiRaccolti: new FormControl(null, null),
      descrizione: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      idTemplateSelect: new FormControl(null, [Validators.required]),
    });
  }

  private modeSelector() {
    this.isNewSegnalazione = this.router.url.endsWith('/compilazione-segnalazione') ? true : false;
    this.buildForm();
    if (!this.isNewSegnalazione) {
      if (this.router.url.includes('compilazione-segnalazione')) {
        if (this.router.url.includes('dettaglio-segnalazione-storico')) {
          this.isDettaglio = true;
          this.isModifica = false;
          this.form = new FormGroup({
            idDatiRaccolti: new FormControl({ value: null, disabled: true }, null),
            descrizione: new FormControl({ value: null, disabled: true }, [Validators.required, Validators.maxLength(100)]),
            idTemplateSelect: new FormControl({ value: null, disabled: true }, [Validators.required]),
          });
        }
        else {
          this.isDettaglio = false;
          this.isModifica = true;
        }
      } else if (this.router.url.includes('dettaglio-segnalazione')) {
        this.isModifica = false;
        this.isDettaglio = true;
        this.form = new FormGroup({
          idDatiRaccolti: new FormControl({ value: null, disabled: true }, null),
          descrizione: new FormControl({ value: null, disabled: true }, [Validators.required, Validators.maxLength(100)]),
          idTemplateSelect: new FormControl({ value: null, disabled: true }, [Validators.required]),
        });
      }
    } else this.isModifica = this.router.url.endsWith('/compilazione-segnalazione') ? true : false;
  }

  caricaFormPerSegnalazione(idTemplate: number) {
    this.caricaFormMorfeo(idTemplate);
    this.form.get('idTemplateSelect').disable();
  }

  caricaFormMorfeo(idTemplate: number, idDatiRaccolti?: number, dataStoricizzazione?: Date) {
    if (this.isDettaglioStoricoSegnalazione) {
      this.templateService.getJsonTemplateStorico(idTemplate, idDatiRaccolti, dataStoricizzazione).subscribe(ret => {
        this.valorizzaCallbacks(ret);
      }, err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false,
        });
      });
    } else {
      this.templateService.getJsonTemplate(idTemplate, idDatiRaccolti).subscribe(ret => {
        this.valorizzaCallbacks(ret);
      }, err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false,
        });
      });
    }
  }

  valorizzaCallbacks(json: any) {
    this.components = json.components;
    let coordinate: Array<any> = json.components
      .filter(elem => elem.type == "columns"); //al momento usiamo columns solo come contenitore di coordinate e relativi pulsanti

    coordinate.forEach(elem => {
      this.buttonService.registerCallback(elem.key + 'BTN', () => {
        this.onOpenDialog(elem.key, elem.solaLettura);
      });
    });

    this.recuperatoFormMorfeo = true;
    this.formJson = json;
  }

  onVisualizzaStorico() {
    this.router.navigate([this.router.url + "/storico-segnalazione"])
  }

  onSaveEvent() {

    this.morfeoValidation(this.formRef.f.form);
    this.markAsUntouched(this.formRef.f.form);

    if (this.form.valid) {

      if (!this.recuperatoFormMorfeo) {
        this.alertsCenterService.showAlert({
          message: `Impossibile procedere con il salvataggio, non è stato possibile recuperare il form da compilare`,
          type: 'danger',
          autoClosable: false
        });
        return;
      }

      let newAnaDatiRaccolti: ModelEventiCalamitosi.AnaDatiRaccoltiDTO = {
        idDatiRaccolti: this.form.controls.idDatiRaccolti.value ? this.form.controls.idDatiRaccolti.value : null,
        idEnte: 0,
        idEvento: Number(this.route.snapshot.params.id),
        idTemplate: this.form.controls.idTemplateSelect.value,
        jsonAttributi: JSON.stringify(this.formRef.f.form.value),
        opzioni: '',
        descrizione: this.form.controls.descrizione.value,
        salvataggioPreventivo: false
      }
      this.segnalazioniService.upsertSegnalazione(newAnaDatiRaccolti).toPromise().then(res => {
        this.alertsCenterService.showAlert({
          message: `Salvataggio effettuato con successo`,
          type: 'success',
          autoClosable: false
        });
        //TODO: stabilire il routing in caso di success
        this.statoSegnalazione = res.body.stato;
        this.router.navigate(['lista-segnalazioni/' + res.body.idEvento + '/compilazione-segnalazione/' + res.body.idDatiRaccolti]);
      },
        err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        });
    } else {
      this.markAsTouched(this.form);
      this.alertsCenterService.showAlert({
        message: 'Campi obbligatori non valorizzati in sezione selezione tipo richiesta',
        type: 'danger',
        autoClosable: false,
      });
    }
  }

  onResetEvent() {
    this.formRef.f.form.reset();
  }

  onNavigate() {
    let idEvento = this.route.snapshot.params.id;
    let idSegnalazione = this.route.snapshot.params.idSegnalazione;
    if (this.isDettaglioStoricoSegnalazione) {
      if (this.router.url.includes("compilazione-segnalazione")) {
        this.router.navigate(['lista-segnalazioni/' + idEvento + '/compilazione-segnalazione/' + idSegnalazione + '/storico-segnalazione']);
      } else {
        this.router.navigate(['lista-segnalazioni/' + idEvento + '/dettaglio-segnalazione/' + idSegnalazione + '/storico-segnalazione']);
      }
    } else {
      this.router.navigate(['/lista-segnalazioni/' + idEvento]);
    }
  }

  changeStatoSegnalazione(stato: string) {
    this.segnalazioneEditabileService.changeStatoSegnalazione(this.acl, stato, this.route.snapshot.params.idSegnalazione, this.statoSegnalazione, this.statoIntervento);
  }

  openDialogAnomalie() {
    this.dialogSvc.openModalAnomalie('Anomalie', this.route.snapshot.params.idSegnalazione).subscribe();
  }

  changeStatoSegnalazioneCompletare() {
    let stato = 'completare';

    let statoRicevuto;
    let messageStatus;
    let title;
    let message;
    let segnalazioneDto: ModelEventiCalamitosi.SegnalazioneStatusDTO | undefined;
    ({ title, message, segnalazioneDto, statoRicevuto, messageStatus } = this.segnalazioneEditabileService.valorizzazioneMessaggi(this.acl, stato, this.route.snapshot.params.idSegnalazione, this.statoSegnalazione));

    this.dialogSvc.openDialog(title, message).subscribe(
      result => {
        let confirmed = `${result}`;
        if (confirmed == "true") {
          //CASO COMPLETATA
          if (stato == 'completare') {
            this.gestioneCompletamento(segnalazioneDto, messageStatus, statoRicevuto);
          }
        }
      }
    );
  }

  private gestioneCompletamento(segnalazioneDto: ModelEventiCalamitosi.SegnalazioneStatusDTO, messageStatus: any, statoRicevuto: any) {
    this.morfeoValidation(this.formRef.f.form);

    if (this.form.valid && this.isMorfeoFormValid(this.formRef.f.form)) {

      //SALVATAGGIO PREVENTIVO
      let newAnaDatiRaccolti: ModelEventiCalamitosi.AnaDatiRaccoltiDTO = {
        idDatiRaccolti: this.form.controls.idDatiRaccolti.value ? this.form.controls.idDatiRaccolti.value : null,
        idEnte: 0,
        idEvento: Number(this.route.snapshot.params.id),
        idTemplate: this.form.controls.idTemplateSelect.value,
        jsonAttributi: JSON.stringify(this.formRef.f.form.value),
        opzioni: '',
        descrizione: this.form.controls.descrizione.value,
        salvataggioPreventivo: true
      };
      this.segnalazioniService.upsertSegnalazione(newAnaDatiRaccolti).subscribe(res => {
        this.segnalazioniService.changeStatusSegnalazione(segnalazioneDto).subscribe(
          res => {
            this.alertsCenterService.showAlert({
              message: messageStatus,
              type: 'success',
              autoClosable: false
            });
            this.statoSegnalazione = statoRicevuto;
          },
          err => {
            this.alertsCenterService.showAlert({
              message: err.error.esitoServizio.descrizioneEsito,
              type: 'danger',
              autoClosable: false
            });
          });
      },
        err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        });
    }
    else {
      this.markAsTouched(this.formRef.f.form);
      this.markAsTouched(this.form);
      this.alertsCenterService.showAlert({
        message: 'Campi obbligatori per la compilazione non valorizzati',
        type: 'danger',
        autoClosable: false,
      });
    }
  }

  public isRifiutabile() {
    return this.segnalazioneEditabileService.isRifiutabile(this.acl, this.statoSegnalazione, this.abilitazioniPerSegnalazione);
  }

  public isNonRicevuta() {
    return this.segnalazioneEditabileService.isNonRicevuta(this.acl, this.statoSegnalazione, this.abilitazioniPerSegnalazione);
  }

  public isRicevibile() {
    return this.segnalazioneEditabileService.isRicevibile(this.acl, this.statoSegnalazione, this.abilitazioniPerSegnalazione);
  }

  public isConfermabile() {
    return this.segnalazioneEditabileService.isConfermabile(this.acl, this.statoSegnalazione, this.abilitazioniPerSegnalazione);
  }

  public isRiapribileSegnalazione() {
    return this.segnalazioneEditabileService.isRiapribile(this.acl, this.statoSegnalazione, this.statoEvento, this.abilitazioniSegnalazioneEELL.abilitatoCorrezione);
  }

  public isConfermabileSegnalazione() {
    return this.segnalazioneEditabileService.isConfermabileSegnalazione(this.statoSegnalazione, this.canUpdate, this.acl);
  }

  public isEsportabile() {
    return this.segnalazioneEditabileService.isEsportabile(this.statoSegnalazione, this.canUpdate);
  }

  public canShowAnomalie() {
    let idSegnalazione = this.route.snapshot.params.idSegnalazione;
  }

  isMorfeoFormValid(form: FormGroup) {
    //il FE, se vede come stato di un control 'disabled' o 'readonly' considera
    //la form invalida, il controllo ora avviene su tutto i campi ed è davvero invalida
    //se e solo se è presente un campo con status = 'INVALID';
    let isValid: boolean = true;
    for (const key in form.controls) {
      let tempVal = form.get(key);
      if (tempVal.status === 'INVALID') {
        isValid = false;
        break;
      }
    }
    return isValid;
  }

  /**
   *
   * ----------------------------Metodi privati per modificare validator e stato della form morfeo ed altre form--------------------------
   */

  private isAlmenoUnElementoRenderizzato(): boolean {

    let renderizzato = this.components
      .filter(elem => {
        return elem.key.substring(0, 1) != "$";
      })
      .find(elemtot => {
        let elem = elemtot.key;
        if (elemtot.type != 'columns') {
          if (this.isElementoRenderizzato(elem)) {
            return true;
          }
        }
        return false;
      });

    return renderizzato != null;
  }

  private isElementoRenderizzato(elem: string): boolean {
    if (document.querySelectorAll(`[ng-reflect-name="${elem}"]`).length > 0) {
      return true;
    }

    return false;
  }

  private morfeoValidation(form: FormGroup) {
    for (const key in form.controls) {
      let tempVal = form.get(key);
      tempVal.setValue(tempVal.value);
      tempVal.markAsDirty();
    }

    if (!this.isModifica) {
      if (this.components != undefined && this.components != null) {
        this.components
          .forEach(elemtot => {
            let elem = elemtot.key;
            if (elemtot.type == 'selectboxes') {
              this.disabilitaElementoMultiselect(elem, elemtot.label);
            }
          });
      }
    }

    if (this.components != undefined && this.components != null) {
      this.components
        .filter(elem => elem.solaLettura == true)
        .forEach(elemtot => {
          let elem = elemtot.key;
          if (elemtot.type == 'columns') {
            this.disabilitaElemento(elem + 'LAT', null);
            this.disabilitaElemento(elem + 'LON', null);
          } else if (elemtot.type == "selectboxes") {
            this.disabilitaElementoMultiselect(elem, elemtot.label);
          } else {
            this.disabilitaElemento(elem, elemtot.label);
          }
        });
    }
  }

  private disabilitaElementoMultiselect(fullElem: string, label: string) {
    let elem = fullElem.substring(0, 30);
    let searchForElem = `[ng-reflect-name="${elem}"]`;
    let searchForElemAndLabel = `[ng-reflect-name="${elem}"][data-placeholder="${label}"]`;
    let elemFromDoc = document.querySelectorAll(searchForElem);
    let htmlElem = elemFromDoc[0];
    if (elemFromDoc.length > 1) { //è ambiguo, verifichiamo anche la label
      htmlElem = document.querySelectorAll(searchForElemAndLabel)[0];
    }
    if (htmlElem != undefined) {
      htmlElem.setAttribute('readonly', 'true');
      let matcheckboxList = htmlElem.parentElement;
      let legend = matcheckboxList.parentElement.children[0];
      if (legend != undefined && legend != null) {
        (legend as HTMLElement).style.backgroundColor = 'white';
      }
      htmlElem.parentElement.parentElement.style.backgroundColor = 'white';
      // Front-end it's the best place to work R.B.
      let j = 0;
      for (j = 0; j < matcheckboxList.children.length; j++) {
        var child = matcheckboxList.children[j];
        if (child.tagName.toLowerCase() == "mat-checkbox" || child.className == "selectAll") {
          var c = (child as HTMLElement).style.pointerEvents = 'none';
        }
      }
    }
  }

  private disabilitaElemento(fullElem: string, label: string) {
    let elem = fullElem.substring(0, 30);
    if (document.querySelectorAll(`[ng-reflect-name="${elem}"]`).length > 1) { //è ambiguo, verifichiamo anche la label
      let htmlElem = document.querySelectorAll(`[ng-reflect-name="${elem}"][data-placeholder="${label}"]`)[0];
      if (htmlElem != undefined) {
        htmlElem.setAttribute('readonly', 'true');
        document.querySelectorAll(`[ng-reflect-name="${elem}"][data-placeholder="${label}"]`)[0].parentElement.parentElement.style.pointerEvents = 'none';
        document.querySelectorAll(`[ng-reflect-name="${elem}"][data-placeholder="${label}"]`)[0].parentElement.parentElement.style.backgroundColor = 'white';
      }
    } else { //non è ambiguo, si può procedere
      let htmlElem = document.querySelectorAll(`[ng-reflect-name="${elem}"]`)[0];
      if (htmlElem != undefined) {
        htmlElem.setAttribute('readonly', 'true');
        document.querySelectorAll(`[ng-reflect-name="${elem}"]`)[0].parentElement.parentElement.style.pointerEvents = 'none';
        document.querySelectorAll(`[ng-reflect-name="${elem}"]`)[0].parentElement.parentElement.style.backgroundColor = 'white';
      }
    }
  }

  private disabilitaElemento2(elem: string, label: string) {
    let htmlElem = document.querySelectorAll(`[ng-reflect-name="${elem}"][data-placeholder="${label}"]`)[0];
    if (htmlElem != undefined) {
      htmlElem.setAttribute('readonly', 'true');
      document.querySelectorAll(`[ng-reflect-name="${elem}"][data-placeholder="${label}"]`)[0].parentElement.parentElement.style.pointerEvents = 'none';
      document.querySelectorAll(`[ng-reflect-name="${elem}"][data-placeholder="${label}"]`)[0].parentElement.parentElement.style.backgroundColor = 'white';
    }
  }

  private markAsTouched(form: FormGroup) {
    for (const key in form.controls) {
      form.get(key).markAsTouched();
    }
  }

  private markAsUntouched(form: FormGroup) {
    for (const key in form.controls) {
      form.get(key).markAsUntouched();
    }
  }

  onEsportaSegnalazione() {
    let idSegnalazione = this.route.snapshot.params.idSegnalazione;
    this.segnalazioniService.downloadReportSingolaSegnalazione(idSegnalazione).subscribe(
      response => {
        let dataType = response.type.toString();
        let binaryData = [];
        binaryData.push(response.body);
        let contentDisposition = response.headers.get('content-disposition')
        let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
        filename = filename.replace(/"/g, '');
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }, err => {
        this.alertsCenterService.showAlert({
          message: 'Errore in fase di download del file...',
          type: 'danger',
          autoClosable: false,
        });
      })
  }

  onOpenDialog(buttonName: string, solaLettura: boolean) {
    let textLat = buttonName + "LAT";
    let textLon = buttonName + "LON";

    let baseLat = this.formRef.f.form.value[textLat];
    let baseLon = this.formRef.f.form.value[textLon];
    let dialogRef;
    let modificabile = this.isModifica && !solaLettura;

    if (baseLat == undefined || baseLat == null || baseLon == undefined || baseLon == null) {
      dialogRef = this.dialog.open(MapComponent, {
        data: {
          x: environment.defaultMapCoordinates.data.x,
          y: environment.defaultMapCoordinates.data.y,
          isModifica: modificabile
        }
      });
    } else {
      dialogRef = this.dialog.open(MapComponent, {
        data: {
          x: baseLat,
          y: baseLon,
          isModifica: modificabile
        }
      });
    }

    const sub = dialogRef.componentInstance.onAdd.subscribe(($event) => {
      let value = {
        [textLat]: "" + $event.lat,
        [textLon]: "" + $event.lng
      };

      this.formRef.f.form.patchValue(value);
    });
  }

  ngOnDestroy() {
    this.sottoscrizione.unsubscribe();
    this.sottoscrizioneFLRettificata.unsubscribe();
  }
}

